import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DebitCreditPdfRes;
export const DebitCreditPdfTodo = createAsyncThunk('DebitCreditPdf', async (data) => {
    try {
        const res = await axios({
            method: "post",
            url: process.env.REACT_APP_API_URL + 'pdf_debit_credit_note',
            data: {
                "vtrans_code": data,
                "ibusiness_area_id": localStorage.getItem('ibusiness_area_id'),
            },
            headers: { "Content-Type": "application/json" }
        })
        return DebitCreditPdfRes = res.data

    } catch (error) {
        return DebitCreditPdfRes = error.response.data
    }
})


